import React, { useState, useEffect } from "react";
import logo from "../../assets/images/vms-logo.png";

// 🔥 API ya correcta
const API = "https://vms.hexagons.tech/api";

export default function VisitorPublic() {

  const [form, setForm] = useState({
    name: "",
    idNumber: "",
    company: "",
    department: "",
    reason: "",
    reasonDetail: ""
  });

  const [success, setSuccess] = useState(false);

  useEffect(() => {

    const tryFullscreen = async () => {
      try {
        const el = document.documentElement;

        if (el.requestFullscreen) {
          await el.requestFullscreen();
        } else if (el.webkitRequestFullscreen) {
          el.webkitRequestFullscreen();
        } else if (el.msRequestFullscreen) {
          el.msRequestFullscreen();
        }

      } catch (err) {
        console.log("Fullscreen bloqueado por navegador");
      }
    };

    tryFullscreen();

    const blockKeys = (e) => {
      if (
        e.key === "F11" ||
        e.key === "Escape" ||
        (e.ctrlKey && ["r", "w", "t"].includes(e.key.toLowerCase()))
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("keydown", blockKeys);
    return () => document.removeEventListener("keydown", blockKeys);

  }, []);

  // ============================
  // SUBMIT
  // ============================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.idNumber || !form.reason || !form.department) {
      alert("Complete los campos obligatorios");
      return;
    }

    try {
      const res = await fetch(`${API}/public/visitor`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(form)
      });

      if (!res.ok) {
        throw new Error("Error en servidor");
      }

      setForm({
        name: "",
        idNumber: "",
        company: "",
        department: "",
        reason: "",
        reasonDetail: ""
      });

      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);

    } catch (err) {
      console.error(err);
      alert("Error al registrar");
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">

      {/* HEADER */}
      <div className="bg-primary py-4 shadow-md flex justify-center">
        <img src={logo} alt="Alonso Forwarding" className="h-12" />
      </div>

      {/* CONTENIDO */}
      <div className="flex-1 flex items-center justify-center p-4">

        <div className="w-full max-w-md bg-white p-6 rounded-2xl shadow-xl border-l-4 border-primary">

          <h2 className="text-xl font-bold text-primary text-center mb-2">
            Registro de Visitante
          </h2>

          <p className="text-center text-gray-500 mb-4 text-sm">
            Complete la información para ingresar
          </p>

          {success && (
            <div className="bg-success text-white text-center p-2 rounded mb-4">
              Registro exitoso
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-3">

            <input
              placeholder="Nombre completo"
              className="w-full border p-3 rounded-lg"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />

            <input
              placeholder="Cédula de Identidad"
              className="w-full border p-3 rounded-lg"
              value={form.idNumber}
              onChange={(e) => setForm({ ...form, idNumber: e.target.value })}
            />

            <input
              placeholder="Empresa que Representa"
              className="w-full border p-3 rounded-lg"
              value={form.company}
              onChange={(e) => setForm({ ...form, company: e.target.value })}
            />

            <input
              placeholder="Departamento / Persona a visitar"
              className="w-full border p-3 rounded-lg"
              value={form.department}
              onChange={(e) => setForm({ ...form, department: e.target.value })}
            />

            <select
              className="w-full border p-3 rounded-lg"
              value={form.reason}
              onChange={(e) => setForm({ ...form, reason: e.target.value })}
            >
              <option value="">Motivo de visita</option>
              <option>Entrega de Documentos</option>
              <option>Entrega de Paquetes</option>
              <option>Entrevista</option>
              <option>Retiro de Documentos</option>
              <option>Reunión</option>
              <option>Servicio Técnico</option>
              <option>Otros</option>
            </select>

            {/* 🔥 CAMPO DINÁMICO (AGREGADO SIN ROMPER NADA) */}
            {[
              "Entrega de Documentos",
              "Entrega de Paquetes",
              "Otros",
              "Entrevista",
              "Reunión",
              "Servicio Técnico"
            ].includes(form.reason) && (
              <input
                placeholder={
                  ["Entrevista", "Reunión","Servicio Técnico"].includes(form.reason)
                    ? "Número de visitante / badge temporal"
                    : "Detalle o Destinatario"
                }
                className="w-full border p-3 rounded-lg"
                value={form.reasonDetail}
                onChange={(e) =>
                  setForm({ ...form, reasonDetail: e.target.value })
                }
              />
            )}

            <button className="w-full bg-primary text-white py-3 rounded-lg">
              Registrar ingreso
            </button>

          </form>
        </div>
      </div>

      {/* FOOTER */}
      <div className="text-center text-xs text-gray-400 pb-3">
        Desarrollado por Hexagons Tech SRL - © {new Date().getFullYear()}
      </div>
    </div>
  );
}